var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFewCloudsDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 225 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_303_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.918 91.1872C154.025 90.5872 154.08 89.97 154.08 89.34C154.08 83.4468 149.241 78.6694 143.272 78.6694C138.834 78.6694 135.021 81.3097 133.357 85.0859C132.008 83.9365 130.258 83.2425 128.346 83.2425C124.083 83.2425 120.626 86.6929 120.626 90.9491C120.626 91.1861 120.637 91.4206 120.658 91.6521C118.607 92.6438 117.195 94.7247 117.195 97.1312C117.195 100.499 119.96 103.229 123.371 103.229H152.536C155.947 103.229 158.712 100.499 158.712 97.1312C158.712 94.233 156.664 91.807 153.918 91.1872Z",
    fill: "url(#paint0_linear_303_720)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_303_720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.4322,
    y: 77.5,
    width: 70.1694,
    height: 66.0762,
    rx: 33.0381,
    fill: "#FFEF9A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_303_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.508 110.538C143.508 127.816 129.633 141.822 112.517 141.822C95.4008 141.822 81.5255 127.816 81.5255 110.538C81.5255 93.2604 95.4008 79.2542 112.517 79.2542C129.633 79.2542 143.508 93.2604 143.508 110.538Z",
    fill: "url(#paint1_linear_303_720)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_303_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.957 128.849C105.113 127.97 105.194 127.065 105.194 126.141C105.194 117.503 98.0844 110.5 89.3141 110.5C82.794 110.5 77.1917 114.37 74.7461 119.906C72.7648 118.221 70.1938 117.203 67.3843 117.203C61.1198 117.203 56.0413 122.261 56.0413 128.5C56.0413 128.847 56.0571 129.191 56.0879 129.531C53.0748 130.984 51 134.035 51 137.562C51 142.498 55.0627 146.5 60.0744 146.5H102.926C107.937 146.5 112 142.498 112 137.562C112 133.314 108.991 129.758 104.957 128.849Z",
    fill: "url(#paint2_linear_303_720)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_303_720",
    x: 117.195,
    y: 78.6694,
    width: 41.5169,
    height: 34.5593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_720"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_303_720",
    x: 0.43219,
    y: 0.5,
    width: 224.169,
    height: 220.076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.5,
    result: "effect1_foregroundBlur_303_720"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_303_720",
    x: 81.5255,
    y: 79.2542,
    width: 61.983,
    height: 67.5676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.81 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_720"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_303_720",
    x: 51,
    y: 110.5,
    width: 61,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_720"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_720",
    x1: 119.836,
    y1: 101.036,
    x2: 161.613,
    y2: 69.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_720",
    x1: 107.809,
    y1: 127.566,
    x2: 133.672,
    y2: 82.6311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_720",
    x1: 54.8799,
    y1: 143.286,
    x2: 116.159,
    y2: 97.1906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsDay);
export default __webpack_public_path__ + "static/media/Few-Clouds_Day.f9a113030217d702859ee387f9047081.svg";
export { ForwardRef as ReactComponent };